import { connect } from 'react-redux';
import { isNonEmptyString, createCustomPropType } from '../../../js/app/react/validators';
import View from './ValidationView';

import { errorMessages as errorMessagesSelector } from '../AdvWorkflow/AdvWorkflowSelector';

const MAX_DISPLAYED_ERRORS = 3;

const mapStateToProps = (state, ownProps) => ({
  errorMessages: errorMessagesSelector(state, ownProps).slice(0, MAX_DISPLAYED_ERRORS),
});
const ValidationContainer = connect(mapStateToProps)(View);
ValidationContainer.propTypes = {
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
};

export default ValidationContainer;
